/*LIBRARY*/
import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_layer } from "../../App/actions/layerActions";
import { set_value_bi } from "../../App/actions/biActions";

/*PICTURE*/
import icon_zoom_in from "../../Assets/svg/icon_zoom_in.svg";
import icon_zoom_out from "../../Assets/svg/icon_zoom_out.svg";
import icon_compass from "../../Assets/svg/icon_compass.svg";
import icon_gps from "../../Assets/svg/icon_gps.svg";
import icon_sini_with_text from "../../Assets/svg/icon_sini_with_text.svg";

/*FUNCTION*/
import generate_uuid from "../../App/validation/generate_uuid";
import { ErrorContext } from "../../Debug/ErrorHandler/ErrorContext";

/*DATA*/

/*CONST*/

const BI_MAP_CONTROL = ({ layer, bi, set_value_layer, set_value_bi }) => {
  const { handleError } = useContext(ErrorContext);
  const { map_object } = layer;

  const [geo_location_status, set_geo_location_status] = useState("pending");
  const [gps_reset, set_gps_reset] = useState(false);

  const compass_ref = useRef(null);
  const gps_timeout_ref = useRef(null);

  const update_compass_rotation = useCallback(() => {
    handleError(() => {
      if (map_object && compass_ref.current) {
        const bearing = map_object.getBearing();
        compass_ref.current.style.transform = `rotate(${-bearing}deg)`;
      }
    })();
  }, [map_object, handleError]);

  useEffect(() => {
    handleError(() => {
      if (map_object) {
        map_object.on("rotate", update_compass_rotation);
      }
    })();

    return () => {
      handleError(() => {
        if (map_object) {
          map_object.off("rotate", update_compass_rotation);
        }
      })();
    };
  }, [map_object, update_compass_rotation, handleError]);

  useEffect(() => {
    return () => {
      if (gps_timeout_ref.current) {
        clearTimeout(gps_timeout_ref.current);
      }
    };
  }, []);

  const toggle_sini = () => {
    handleError(() => {
      set_value_bi({
        key: "modal_sini",
        value: !bi?.modal_sini,
      });
    })();
  };

  const on_zoom_in = () => {
    handleError(() => {
      if (map_object) {
        map_object.zoomIn();
      }
    })();
  };

  const on_zoom_out = () => {
    handleError(() => {
      if (map_object) {
        map_object.zoomOut();
      }
    })();
  };

  const on_reset_compass = () => {
    handleError(() => {
      if (map_object) {
        map_object.easeTo({
          pitch: 0,
          bearing: 0,
          duration: 1000,
        });
      }
    })();
  };

  const on_geolocate = () => {
    handleError(() => {
      set_geo_location_status("loading");
      set_gps_reset(false);

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const uuid = generate_uuid();
            const {
              latitude,
              longitude,
              accuracy,
              altitude,
              altitudeAccuracy,
              heading,
              speed,
            } = position.coords;

            const gps_object = {
              uuid: uuid,
              latitude,
              longitude,
              accuracy,
              altitude,
              altitudeAccuracy,
              heading,
              speed,
            };

            set_value_layer({
              key: "gps_object",
              value: gps_object,
            });

            set_geo_location_status("success");

            if (gps_timeout_ref.current) {
              clearTimeout(gps_timeout_ref.current);
            }
            gps_timeout_ref.current = setTimeout(() => {
              set_gps_reset(true);
            }, 1000);
          },
          () => {
            set_geo_location_status("error");
          },
        );
      } else {
        set_geo_location_status("browser_not_supported");
      }
    })();
  };

  let gps_class = "";
  if (geo_location_status === "loading") {
    gps_class = "icon_rotate";
  } else if (geo_location_status === "success") {
    gps_class = gps_reset ? "icon_reset" : "icon_scale";
  }

  return (
    <main>
      <aside className="map_controls_wrapper_bi">
        <nav className="map_controls_background">
          <section className="map_controls_container">
            <button className="map_button_draw zoom_in" onClick={on_zoom_in}>
              <img alt="Zoom In" src={icon_zoom_in} width={12} />
            </button>
            <div className="separator"></div>
            <button className="map_button_draw zoom_out" onClick={on_zoom_out}>
              <img alt="Zoom Out" src={icon_zoom_out} width={12} />
            </button>
            <div className="separator"></div>
            <button
              className="map_button_draw reset_compass"
              onClick={on_reset_compass}
            >
              <img
                ref={compass_ref}
                id="map_compass"
                alt="Reset Compass"
                src={icon_compass}
                height={17}
              />
            </button>
            <div className="separator"></div>
            <button className="map_button_draw gps_map" onClick={on_geolocate}>
              <img
                id="icon_gps"
                alt="Geolocate"
                src={icon_gps}
                width={15}
                className={gps_class}
              />
            </button>
          </section>
        </nav>
      </aside>

      <button
        className="map_button_control_bi sini_map_bi"
        onClick={toggle_sini}
      >
        <img alt="S" src={icon_sini_with_text} width={28} />
      </button>
    </main>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  bi: state.bi,
});

export default connect(mapStateToProps, {
  set_value_layer,
  set_value_bi,
})(BI_MAP_CONTROL);
